import { render, staticRenderFns } from "./tm-comment.vue?vue&type=template&id=2d935c76&scoped=true"
import script from "./tm-comment.vue?vue&type=script&lang=js"
export * from "./tm-comment.vue?vue&type=script&lang=js"
import style0 from "./tm-comment.vue?vue&type=style&index=0&id=2d935c76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d935c76",
  null
  
)

export default component.exports